import React from "react";
import Image from "next/image";

/**
 * SectionHowItWorks Component
 * Step-by-step guide on how to become an agent
 */
const SectionHowItWorks: React.FC = () => {
  const steps = [
    {
      title: "1. Daftar",
      description:
        "Isi formulir & unggah data dasar (KTP, akun WA/IG, domisili).",
      icon: "/svg/hand.svg",
    },
    {
      title: "2. Verifikasi",
      description:
        "Admin cek kelayakan & kirim hasil (diterima/ ditolak/ revisi).",
      icon: "/svg/checklist.svg",
    },
    {
      title: "3. Tanda Tangan Persetujuan",
      description: "Setujui skema komisi & aturan promosi.",
      icon: "/svg/contract.svg",
    },
    {
      title: "4. Onboarding",
      description: "Dapat kode/link unik, materi promosi, & panduan order.",
      icon: "/svg/office.svg",
    },
    {
      title: "5. Aktif",
      description:
        "Mulai promosi, closing via WA/link Anda, komisi cair sesuai jadwal..",
      icon: "/svg/self.svg",
    },
  ];

  return (
    <div
      data-aos="fade-up"
      className="w-full flex flex-col justify-center px-6 md:px-8 lg:px-0 py-6 md:py-8 lg:py-12 max-w-6xl mx-auto"
    >
      <div className="w-full flex flex-col gap-5 lg:gap-12 items-center">
        <h2 className="font-bold md:text-[40px] text-[24px] tracking-[0.4px] text-base-black text-center m-0">
          Alur Pendaftaran Agent
        </h2>

        {/* Steps */}
        <div className="flex flex-col md:flex-row md:flex-nowrap lg:flex-nowrap gap-8 md:justify-evenly lg:justify-between md:w-full lg:w-full">
          {steps.map((step, index) => (
            <div
              key={index}
              className="flex flex-row md:flex-col gap-4 lg:gap-8 w-full md:w-full lg:w-full items-center"
            >
              {/* Icon */}
              <div className="sm:w-[96px] md:w-full lg:w-full sm:h-[96px] sm:aspect-square md:aspect-square lg:aspect-square bg-[#f5f5f5] border-[6px] border-white rounded-lg flex items-center justify-center p-4 shadow-md">
                <Image
                  src={step.icon}
                  alt={step.title}
                  width={100}
                  height={100}
                  className="w-full h-full object-contain"
                  loading="lazy"
                />
              </div>

              {/* Content */}
              <div className="flex flex-col gap-2 justify-center w-full">
                <p className="md:text-center font-semibold md:text-[24px] text-[18px] leading-7 tracking-[0.2px] text-base-black m-0 w-full">
                  {step.title}
                </p>
                <p className="md:text-center w-full font-normal md:text-base text-[13px] md:leading-7 leading-4 tracking-[0.16px] text-base-grey m-0">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SectionHowItWorks;
